import {Component, OnInit} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from './services/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  /** Authentication status */
  public isAuthenticated: boolean = false;

  /**
   * Constructor for the base app component. Used to initalize services
   * and set up observables for authentication and excluded routes
   * 
   * @param authService 
   * @param router 
   */
  constructor(
    private _toastrService: ToastrService,
    private _userService: UserService,
  ) {
    // Set toastr config
    this._toastrService.toastrConfig.positionClass = 'toast-bottom-right';
    this._toastrService.toastrConfig.timeOut = 10 * 1000;

    // Subscribe to token changes to verify authentication
    this.isAuthenticated = this._userService.authenticated;
    this._userService.authenticated$.subscribe(
      (authenticated: boolean) => {
        this.isAuthenticated = authenticated;
      });
  }

  ngOnInit() {}
}
